import React from 'react';

export interface NextImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: any;
  alt: string;
  width?: number | `${number}`;
  height?: number | `${number}`;
  fill?: boolean;
  quality?: number;
  priority?: boolean;
  unoptimized?: boolean;
  placeholder?: string;
  blurDataURL?: string;
}

export const Image = React.forwardRef<HTMLImageElement, NextImageProps>(function Image(
  { src, alt, width, height, fill, className, style, priority, unoptimized, ...rest },
  ref,
) {
  const imgSrc = typeof src === 'object' && src !== null ? (src.src || src.default || '') : (src || '');

  const computedStyle: React.CSSProperties = {
    ...style,
    ...(fill
      ? {
          position: 'absolute',
          height: '100%',
          width: '100%',
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          objectFit: 'cover',
        }
      : {}),
  };

  return (
    <img
      ref={ref}
      src={imgSrc}
      alt={alt || ''}
      width={width}
      height={height}
      className={className}
      style={computedStyle}
      loading={priority ? 'eager' : 'lazy'}
      {...rest}
    />
  );
});

export default Image;
